import { render, staticRenderFns } from "./AgencyAdmins.vue?vue&type=template&id=47cf732a&scoped=true&"
import script from "./AgencyAdmins.vue?vue&type=script&lang=ts&"
export * from "./AgencyAdmins.vue?vue&type=script&lang=ts&"
import style0 from "./AgencyAdmins.vue?vue&type=style&index=0&id=47cf732a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cf732a",
  null
  
)

export default component.exports